<template>
  <div  class="modal">
    <div class="modal-header">
      <div class="close" @click="$emit('close')">
        <img src="@/assets/images/cancel.svg"/>
      </div>
      <div class="title">
        <span class="lang inuktitut">{{ nameIN }}</span>
        <img src="@/assets/images/chapter.svg"/>
        <span class="lang roman">{{ nameRN }}</span>
      </div>
    </div>
    <div class="modal-content">
      <div class="modal-wrapper">
        <modal-description v-if="description" :description="description"/>
        <modal-item v-for="(item, index) in items" :key="index" :id="item.slug" :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import ModalItem from '@/components/ModalItem.vue'
import ModalDescription from '@/components/ModalDescription.vue'
export default {
  components: {
    ModalItem,
    ModalDescription
  },
  computed: {
    selectedGeometry () {
      return this.$store.state.selectedGeometry
    },
    campsites () {
      return this.$store.state.campSitesData
    },
    items () {
      return this.selectedGeometry ? this.campsites.filter(item => parseInt(item.geometryid) === parseInt(this.selectedGeometry.id)) : []
    },
    nameRN () {
      return this.selectedGeometry && this.selectedGeometry.nameRn ? this.selectedGeometry.nameRn : ''
    },
    nameIN () {
      return this.selectedGeometry && this.selectedGeometry.nameIn ? this.selectedGeometry.nameIn : ''
    },
    description () {
      return this.selectedGeometry && this.selectedGeometry.description ? this.selectedGeometry.description : ''
    }
  }
}
</script>

<style lang="scss">
  .modal {
    pointer-events: auto;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 720px;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
    background-color: white;
    display: flex;
    flex-direction: column;
    box-shadow: 4px 0 24px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    .date-gradient.top {
      background-image: linear-gradient(to top, rgba(255, 255, 255, 0), #ffffff) !important;
    }
    .date-gradient.bottom {
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff) !important;
    }
    .modal-header {
      display: flex;
      flex-direction: row;
      margin-left: 48px;
      padding-top: 48px;
      align-content: center;
      @media only screen and (max-width: 768px) {
        margin: 0;
      }
      .close img {
        width: 24px;
        height: 24px;
        cursor: pointer;
        @media only screen and (max-width: 768px) {
          position: absolute;
          top: 24px;
          right: 24px;
          left: auto;
        }
      }
      .title {
        display: flex;
        height: 24px;
        width: 100%;
        margin-left: 48px;
        padding-bottom: 24px;
        align-items: center;
        box-shadow: inset 0 -1px 0 0 #e2e7e8;
        background-color: #ffffff;
        img {
          width: 24px;
          height: 24px;
        }
        .lang.roman {
          font-family: Rubik-Medium;
          font-size: 16px;
          text-transform: uppercase;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: #18333c;
        }
        .lang.inuktitut {
          font-family: Pigiarniq-Bold;
          font-size: 16px;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: #18333c;
        }

      }
    }
    // .modal-content::-webkit-scrollbar {
    //   display: block;
    // }

    .modal-content {
      overflow-y: scroll;
      overflow-x: hidden;
      .modal-wrapper {
        flex: 1;
        height: 720px; // todo: improve
      }
    }
  }

</style>
